import React, { useState, useEffect } from "react";

export default function DashboardCard({ title, icon, gradient, counts, progress = 70, onClick, dashBoardLoading }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const formatIndianNumber = (num) => {
    return new Intl.NumberFormat("en-IN").format(num || 0);
  };

  const cardPadding = isMobile ? "20px" : "35px";
  const minHeight = isMobile ? "120px" : "150px";
  const titleFontSize = isMobile ? "16px" : "18px";
  const countsFontSize = isMobile ? "16px" : "18px";
  const countsLabelSize = isMobile ? "10px" : "11px";

  return (
    <div
      onClick={onClick}
      style={{
        background: gradient,
        color: "#fff",
        borderRadius: "15px",
        padding: cardPadding,
        cursor: "pointer",
        position: "relative",
        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: minHeight,
        overflow: "hidden",
        transition: "transform 0.3s, box-shadow 0.3s"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-5px)";
        e.currentTarget.style.boxShadow = "0 12px 25px rgba(0,0,0,0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.2)";
      }}
    >

      {/* Semi-transparent background icon */}
      <span
        className="material-icons"
        style={{
          position: "absolute",
          right: "-10px",
          bottom: "-10px",
          fontSize: isMobile ? "60px" : "80px",
          opacity: 0.15,
          pointerEvents: "none",
          transform: "rotate(15deg)"
        }}
      >
        {icon}
      </span>

      {/* Counts */}
      {counts && (
        <div
          style={{
            position: "absolute",
            top: isMobile ? "12px" : "18px",
            right: isMobile ? "12px" : "20px",
            display: "flex",
            alignItems: "center",
            gap: isMobile ? "6px" : "8px",
            zIndex: 5,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >

          {/* INDEXING - Completed Count */}
          {counts.completedCount !== undefined && (
            <div
              style={{
                textAlign: "center",
                minWidth: isMobile ? "35px" : "40px",
              }}
            >
              <div
                style={{
                  fontSize: countsFontSize,
                  fontWeight: "700",
                  lineHeight: "1",
                }}
              >
                {/* {dashBoardLoading ? "Loading..." : formatIndianNumber(counts.completedCount ?? 0)} */}
                {
                  dashBoardLoading ? (
                    <div
                      className="preloader-wrapper small active"
                      style={{ width: "20px", height: "20px", display: "inline-block" }}
                    >
                      <div className="spinner-layer spinner-blue-only">
                        <div className="circle-clipper left">
                          <div className="circle"></div>
                        </div>
                        <div className="gap-patch">
                          <div className="circle"></div>
                        </div>
                        <div className="circle-clipper right">
                          <div className="circle"></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    formatIndianNumber(counts.completedCount ?? 0)
                  )
                }
              </div>

              <div
                style={{
                  fontSize: countsLabelSize,
                  opacity: 0.9,
                  marginTop: "2px",
                  whiteSpace: "nowrap",
                }}
              >
                Done
              </div>
            </div>
          )}


          {/* INSTALLATION - Allotted Count */}

          {counts.countAllotted !== undefined && (
            <div
              style={{
                textAlign: "center",
                minWidth: isMobile ? "35px" : "40px",
              }}
            >
              <div
                style={{
                  fontSize: countsFontSize,
                  fontWeight: "700",
                  lineHeight: "1",
                }}
              >
                {formatIndianNumber(counts.countAllotted ?? 0)}
              </div>

              <div
                style={{
                  fontSize: countsLabelSize,
                  opacity: 0.9,
                  marginTop: "2px",
                  whiteSpace: "nowrap",
                }}
              >
                Allotted
              </div>
            </div>
          )}


          {/* INSTALLATION DIVIDER */}
          {counts.countAllotted !== undefined &&
            counts.countPending !== undefined && (
              <div
                style={{
                  width: "1px",
                  height: isMobile ? "25px" : "30px",
                  background: "rgba(255,255,255,0.5)",
                }}
              />
            )}


          {/* INSTALLATION - Pending Count */}
          {counts.countPending !== undefined && (
            <div
              style={{
                textAlign: "center",
                minWidth: isMobile ? "35px" : "40px",
              }}
            >
              <div
                style={{
                  fontSize: countsFontSize,
                  fontWeight: "700",
                  lineHeight: "1",
                }}
              >
                {formatIndianNumber(counts.countPending ?? 0)}
              </div>

              <div
                style={{
                  fontSize: countsLabelSize,
                  opacity: 0.9,
                  marginTop: "2px",
                  whiteSpace: "nowrap",
                }}
              >
                Pending
              </div>
            </div>
          )}


          {/* QC - Pending Count */}
          {counts.pendingCount !== undefined && (
            <div
              style={{
                textAlign: "center",
                minWidth: isMobile ? "35px" : "40px",
              }}
            >
              <div
                style={{
                  fontSize: countsFontSize,
                  fontWeight: "700",
                  lineHeight: "1",
                }}
              >
                {formatIndianNumber(counts.pendingCount ?? 0)}
              </div>

              <div
                style={{
                  fontSize: countsLabelSize,
                  opacity: 0.9,
                  marginTop: "2px",
                  whiteSpace: "nowrap",
                }}
              >
                Pending
              </div>
            </div>
          )}


          {/* QC DIVIDER */}
          {counts.pendingCount !== undefined &&
            counts.approvedCount !== undefined && (
              <div
                style={{
                  width: "1px",
                  height: isMobile ? "25px" : "30px",
                  background: "rgba(255,255,255,0.5)",
                }}
              />
            )}


          {/* QC - Approved Count */}
          {counts.approvedCount !== undefined && (
            <div
              style={{
                textAlign: "center",
                minWidth: isMobile ? "35px" : "40px",
              }}
            >
              <div
                style={{
                  fontSize: countsFontSize,
                  fontWeight: "700",
                  lineHeight: "1",
                }}
              >
                {formatIndianNumber(counts.approvedCount ?? 0)}
              </div>

              <div
                style={{
                  fontSize: countsLabelSize,
                  opacity: 0.9,
                  marginTop: "2px",
                  whiteSpace: "nowrap",
                }}
              >
                Approved
              </div>
            </div>
          )}

        </div>
      )}
      {/* Foreground content */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: isMobile ? "8px" : "10px",
          fontSize: titleFontSize,
          zIndex: 2,
          flexWrap: "wrap"
        }}
      >
        <span
          className="material-icons"
          style={{ fontSize: isMobile ? "24px" : "28px", flexShrink: 0 }}
        >
          {icon}
        </span>

        <strong style={{ wordWrap: "break-word" }}>{title}</strong>
      </div>
      {counts && (
        <div>
          {counts.completedCount !== undefined && (
            (dashBoardLoading?"":<div   style={{
                  fontSize: countsFontSize,
                  fontWeight: "700",
                  lineHeight: "1",
                }}>{counts.userCompletedCount} out of {counts.completedCount}</div>)
          )}
        </div>
      )}
      {/* Progress bar */}
      <div
        style={{
          height: "6px",
          width: "100%",
          background: "rgba(255,255,255,0.4)",
          borderRadius: "3px",
          marginTop: isMobile ? "10px" : "15px",
          overflow: "hidden",
          zIndex: 2
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            background: "#fff",
            borderRadius: "3px",
            transition: "width 0.3s"
          }}
        />
      </div>

    </div>
  );
}
